module.exports = __webpack_public_path__ + "img/Weapon_255.c05a8a5b.png";